import React from 'react'
import { MenuItem } from '@mui/material'

import Selector from '../../Utils/Selector'

export default function CalendrierSelector({
  calendrier, setCalendrier, calendriers
}) {
  return (
    <Selector
      key={1}
      title="Calendrier"
      value={calendrier}
      handleChange={(data) => setCalendrier(data)}
    >
      {calendriers.map((c) => (
        <MenuItem
          key={c}
          value={c}
          children={c} />
      ))}
    </Selector>
  )
}
